export const STREAK_LEVELS = [5, 10, 20, 50];
export const STREAK_AWARD_ID = "step-streak";
export function streakNextLevelLabel(streak) {
    if (streak.nextDays === null)
        return "Every level reached.";
    const target = streak.level ? "the next level" : "your first level";
    if (streak.current === 0) {
        return `Meet your daily step goal for ${streak.nextDays} days in a row to reach ${target}.`;
    }
    return `${streak.current} of ${streak.nextDays} days toward ${target}.`;
}
export function streakAward(data) {
    const known = data?.bestStreakDays !== undefined;
    const best = Math.max(data?.bestStreakDays ?? 0, data?.streakDays ?? 0);
    const current = data?.streakDays ?? 0;
    const level = known ? STREAK_LEVELS.filter((days) => best >= days).length : 0;
    const earnedDays = level ? (STREAK_LEVELS[level - 1] ?? null) : null;
    const nextDays = STREAK_LEVELS[level] ?? null;
    return {
        id: STREAK_AWARD_ID,
        kind: "streak",
        title: "Keep the flame",
        collection: "Daily movement",
        description: "Small efforts, day after day. One award that grows with your consistency.",
        requirement: "Meet your daily step goal to grow your streak. Rest days hold it without adding a day.",
        status: !known ? "preview" : level ? "reached" : current ? "in-progress" : "available",
        progress: !known ? null : nextDays ? Math.min(1, current / nextDays) : 1,
        remainingMeters: null,
        ordinal: level,
        routeInstanceId: null,
        streak: known
            ? { current, best, level, earnedDays, nextDays, frozen: data.restDay.todayDeclared }
            : undefined,
    };
}
//# sourceMappingURL=streak-award.js.map